import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center mb-2 bg-white rounded-xl border border-gray-300 border-solid" }
const _hoisted_2 = { class: "flex flex-col justify-center w-full rounded-xl" }
const _hoisted_3 = {
  class: "flex justify-between items-center self-stretch my-auto w-5",
  "aria-label": "Toggle cards styling"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full px-6 pb-5 rounded-xl max-md:px-5",
  ref: "collapsible"
}
const _hoisted_6 = { class: "flex flex-col mb-4 mt-4 text-left pb-4" }
const _hoisted_7 = { class: "flex flex-col mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex gap-10 justify-between items-center px-6 py-5 rounded-xl w-full bg-slate-50 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
          _createElementVNode("div", { class: "flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-black font-semibold text-sm" }, " 4 "),
          _createElementVNode("h3", { class: "text-sm font-semibold text-black" }, "Website Url")
        ], -1)),
        _createElementVNode("button", _hoisted_3, [
          _createElementVNode("div", {
            innerHTML: _ctx.isCollapsed ? _ctx.ARROW_DOWN : _ctx.ARROW_UP
          }, null, 8, _hoisted_4)
        ])
      ]),
      (!_ctx.isCollapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BaseLabel, {
                  forAttr: "websiteUrl",
                  text: `Enter the URL where this will be hosted. We strongly suggest ${_ctx.companyWebsite}/experts`,
                  class: "font-inter text-sm font-medium leading-normal tracking-normal mb-2"
                }, null, 8, ["text"]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localWebsiteUrl) = $event)),
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleWebsiteUrlChange && _ctx.handleWebsiteUrlChange(...args))),
                  placeholder: "Type your text here...",
                  class: "w-full h-12 border rounded-md p-2 resize-none focus:outline-none",
                  rows: "2"
                }, null, 544), [
                  [_vModelText, _ctx.localWebsiteUrl]
                ])
              ])
            ])
          ], 512))
        : _createCommentVNode("", true)
    ])
  ]))
}